import { DEFAULT_LOGIN_PATH, OPENKNOTS_LOGIN_PATH } from './loginOrigin';

/** Buyer WhatsApp links and the create-enquiry deep link use the Open Knots login. */
const OPENKNOTS_LOGIN_ENTRY_PREFIXES = ['/RfqDetailsOpenKnots', '/createRfqOpenKnots'];

export function usesOpenKnotsLogin(pathname) {
    if (!pathname) {
        return false;
    }
    return OPENKNOTS_LOGIN_ENTRY_PREFIXES.some(
        (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
    );
}

/**
 * Signed-out visit target. Open Knots enquiry links keep the original path in
 * `redirect` so login returns the buyer to that screen.
 */
export function buildUnauthenticatedLoginTarget(pathname, search = '', hash = '') {
    const from = `${pathname || ''}${search || ''}${hash || ''}`;
    const loginPath = usesOpenKnotsLogin(pathname) ? OPENKNOTS_LOGIN_PATH : DEFAULT_LOGIN_PATH;
    return {
        loginPath,
        from,
        to: `${loginPath}?redirect=${encodeURIComponent(from)}`,
    };
}
